import React, { useState, useEffect } from 'react';
import './adBanner.scss';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const AdBanner = ({
                      variant = 'banner', // 'banner' | 'card' | 'modal'
                      dismissible = true,
                      storageKey = 'zakovat_ad_dismissed',
                      expiryDays = 7
                  }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // Check if ad was dismissed
        const dismissed = localStorage.getItem(storageKey);
        if (dismissed) {
            const dismissedDate = new Date(dismissed);
            const now = new Date();
            const daysSinceDismissal = (now - dismissedDate) / (1000 * 60 * 60 * 24);

            if (daysSinceDismissal < expiryDays) {
                return; // Don't show if recently dismissed
            }
        }

        // Show with slight delay for better UX
        setTimeout(() => setVisible(true), 1000);
    }, [storageKey, expiryDays]);

    const handleDismiss = () => {
        setVisible(false);
        localStorage.setItem(storageKey, new Date().toISOString());
    };

    const handleClick = () => {
        // Track click (optional - you can add analytics here)
        window.open('https://e-taklifnomalar.uz', '_blank');
    };

    if (!visible) return null;

    return (
        <div className={`ad-banner ad-banner-${variant}`}>
            <div className="ad-container">
                <div className="ad-label">Reklama</div>

                {dismissible && (
                    <button
                        className="ad-close"
                        onClick={handleDismiss}
                        aria-label="Close advertisement"
                    >
                        <CloseIcon />
                    </button>
                )}

                <div className="ad-content">
                    <div className="ad-icon">💍</div>

                    <div className="rek-text">
                        <h3>To'y taklifnomalaringizni onlayn yarating!</h3>
                        <p>
                            12 ta chiroyli shablon • 24 soat bepul • PDF yuklab olish
                        </p>
                    </div>

                    <button
                        className="ad-cta"
                        onClick={handleClick}
                    >
                        <span>Ko'rish</span>
                        <ArrowForwardIcon />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdBanner;
